import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "clearfix" }, null, -1)
const _hoisted_2 = { id: "dashboard" }
const _hoisted_3 = { class: "dashboard-content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { id: "titlebar" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-md-12" }, [
      /*#__PURE__*/_createVNode("h2", null, "Bookings")
    ])
  ])
], -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-12 col-md-12" }
const _hoisted_7 = { class: "dashboard-list-box margin-top-0" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h4", null, "Your Bookings", -1)
const _hoisted_9 = { class: "list-box-listing bookings" }
const _hoisted_10 = { class: "list-box-listing-img" }
const _hoisted_11 = { class: "list-box-listing-content" }
const _hoisted_12 = { class: "inner" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "booking-status pending" }, "Pending", -1)
const _hoisted_14 = { class: "inner-booking-list" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h5", null, "Booking day:", -1)
const _hoisted_16 = { class: "booking-list" }
const _hoisted_17 = { class: "highlighted" }
const _hoisted_18 = { class: "inner-booking-list" }
const _hoisted_19 = /*#__PURE__*/_createVNode("h5", null, "Booking time:", -1)
const _hoisted_20 = { class: "booking-list" }
const _hoisted_21 = { class: "highlighted" }
const _hoisted_22 = { class: "inner-booking-list" }
const _hoisted_23 = /*#__PURE__*/_createVNode("h5", null, "Booking Details:", -1)
const _hoisted_24 = { class: "booking-list" }
const _hoisted_25 = { class: "highlighted" }
const _hoisted_26 = { class: "inner-booking-list" }
const _hoisted_27 = /*#__PURE__*/_createVNode("h5", null, "Contact with restaurant: ", -1)
const _hoisted_28 = { class: "booking-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("ul", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(this.reservations, (reservation) => {
                  return (_openBlock(), _createBlock("li", {
                    class: "pending-booking",
                    key: reservation
                  }, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("img", {
                          src: _ctx.user.photoURL,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("div", _hoisted_11, [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("h3", null, [
                            _createTextVNode(_toDisplayString(reservation.place.name) + " ", 1),
                            _hoisted_13
                          ]),
                          _createVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createVNode("ul", _hoisted_16, [
                              _createVNode("li", _hoisted_17, _toDisplayString(_ctx.toDate(reservation.timeslot.startTime)), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createVNode("ul", _hoisted_20, [
                              _createVNode("li", _hoisted_21, _toDisplayString(_ctx.toTime(reservation.timeslot.startTime)) + " - " + _toDisplayString(_ctx.toTime(reservation.timeslot.endTime)), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createVNode("ul", _hoisted_24, [
                              _createVNode("li", _hoisted_25, _toDisplayString(reservation.noOfGuests) + " guest(s)", 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createVNode("ul", _hoisted_28, [
                              _createVNode("li", null, _toDisplayString(reservation.place.email), 1),
                              _createVNode("li", null, _toDisplayString(reservation.place.phoneNumber), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}